export const formatDate = (timestamp?: number) => {
    if (!timestamp) return '-- --';
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
};

export const formatPlanName = (priceId: string) => {
    if(priceId.includes('All-In-One')){
        return 'All-in-One'
    }
    return priceId
      .split('-')
      .filter(part => !['USD', 'Monthly', 'Yearly'].includes(part))
      .join(' ')
      .replace(/([A-Z])/g, ' $1')
      .trim()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };